
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Hinchey',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/Hinchey.vue